var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white rounded-lg p-3 mx-4 w-[calc(100%-2rem)]" },
    [
      _vm.showShippingFee
        ? _c(
            "div",
            {
              staticClass: "flex justify-between py-2 border-b border-gray-100",
            },
            [
              _c("div", { staticClass: "flex-1" }, [
                _c("div", { staticClass: "text-sm text-gray-800" }, [
                  _vm._v(_vm._s(_vm.$t("products.shippingFee"))),
                ]),
                _c("div", { staticClass: "text-xs text-gray-400" }, [
                  _vm._v(_vm._s(_vm.$t("products.freeShippingNote"))),
                ]),
              ]),
              _c("div", { staticClass: "text-sm text-gray-800 font-medium" }, [
                _vm._v(
                  "RM " +
                    _vm._s(
                      _vm.formatToYuan(
                        _vm.priceInfo && _vm.priceInfo.deliveryPrice
                      )
                    )
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "flex justify-between items-center py-2 border-b border-gray-100",
        },
        [
          _c("span", { staticClass: "text-sm text-gray-800" }, [
            _vm._v(_vm._s(_vm.$t("products.subtotal"))),
          ]),
          _c("span", { staticClass: "text-sm text-gray-800 font-medium" }, [
            _vm._v(
              "RM " +
                _vm._s(
                  _vm.formatToYuan(_vm.priceInfo && _vm.priceInfo.totalPrice)
                )
            ),
          ]),
        ]
      ),
      _vm.isLoggedIn
        ? _c("div", { staticClass: "py-2 border-b border-gray-100" }, [
            _c(
              "div",
              { staticClass: "flex items-center gap-2 flex-wrap" },
              [
                _c("img", {
                  staticClass: "w-4 h-4 inline-block",
                  attrs: { src: _vm.YoyoCoinsSrc, alt: "Yoyo Coins" },
                }),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-xs text-gray-600 flex-1 flex items-center flex-wrap",
                  },
                  [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("products.currentYoyoCoins")) +
                          _vm._s(
                            (_vm.priceInfo && _vm.priceInfo.totalPoint) || 0
                          ) +
                          _vm._s(_vm.$t("products.availableYoyoCoins")) +
                          " "
                      ),
                    ]),
                    _c("van-field", {
                      staticClass:
                        "w-16 border border-gray-100 pr-0 inline-block p-0 ml-2",
                      attrs: { value: _vm.usePoint },
                      on: { input: _vm.onUsePointInput },
                    }),
                    _vm.priceInfo
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("products.yoyoDiscount")) +
                              _vm._s(
                                _vm.priceInfo.pointPrice
                                  ? _vm.formatToYuan(_vm.priceInfo.pointPrice)
                                  : _vm.formatToYuan(_vm.priceInfo.userPoint)
                              ) +
                              "） "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c("van-icon", {
                  attrs: {
                    name: _vm.yoyoUsed ? "checked" : "circle",
                    color: "#ff7a00",
                    size: "20",
                  },
                  on: { click: _vm.useYoyo },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "flex items-center gap-3 py-0 border-b border-gray-100",
        },
        [
          _c("span", { staticClass: "text-sm text-gray-800 min-w-15" }, [
            _vm._v(_vm._s(_vm.$t("products.coupon"))),
          ]),
          _c("van-field", {
            staticClass: "flex-1 pr-0",
            attrs: {
              "input-align": "right",
              readonly: "",
              "is-link": "",
              "arrow-direction": "down",
            },
            on: { click: _vm.handleCouponClick },
            model: {
              value: _vm.selectedCoupon,
              callback: function ($$v) {
                _vm.selectedCoupon = $$v
              },
              expression: "selectedCoupon",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "pt-2" }, [
        _c("div", { staticClass: "flex justify-between items-center" }, [
          _c("span", { staticClass: "text-base font-bold text-gray-800" }, [
            _vm._v(_vm._s(_vm.$t("products.totalAmount"))),
          ]),
          _c("span", { staticClass: "text-lg font-bold" }, [
            _vm._v(
              "RM " +
                _vm._s(
                  _vm.formatToYuan(_vm.priceInfo && _vm.priceInfo.payPrice)
                )
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "coupon-picker" },
        [
          _c(
            "van-popup",
            {
              staticStyle: { height: "60%", "padding-top": "4px" },
              attrs: { position: "bottom" },
              model: {
                value: _vm.showCouponPicker,
                callback: function ($$v) {
                  _vm.showCouponPicker = $$v
                },
                expression: "showCouponPicker",
              },
            },
            [
              _c("van-coupon-list", {
                attrs: {
                  "disabled-title": "",
                  coupons: _vm.couponOptions,
                  "chosen-coupon": _vm.chosenCoupon,
                  "show-exchange-bar": false,
                  "show-count": false,
                  "close-button-text": _vm.$t("coupons.noCoupons"),
                },
                on: { change: _vm.onCouponConfirm },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }